import Cookies from "js-cookie";
import { LOGOUT_USER } from "../../../constants/actionTypes";
import axiosInstance from "../../../helpers/axiosInstance";

export const logout = () => (dispatch) => {
  axiosInstance().post('/v2/oauth/invalidate')
    .then(res => {
        Cookies.remove('companyId');
        Cookies.remove('loginOK');
        Cookies.remove('userLog');
        Cookies.remove('role');
        dispatch({
          type: LOGOUT_USER,
        });
    }).catch((error) => {
        Cookies.remove('companyId');
        Cookies.remove('loginOK');
        Cookies.remove('userLog');
        Cookies.remove('role');
        dispatch({
          type: LOGOUT_USER,
        });
  });
};